export const formatNumber: (val: number, decimalPlaces: number) => string = (
  val: number,
  decimalPlaces: number
) =>
  Number(Math.round(parseFloat(val + 'e' + decimalPlaces)) + 'e-' + decimalPlaces)
    .toFixed(decimalPlaces)
    .toString()
    .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
